<p>
  nps-manager-dashboard works!
</p>



// WEBPACK FOOTER //
// ./src/app/platform/nps-manager-dashboard/nps-manager-dashboard.component.html